import {useContext, useEffect} from 'preact/hooks';

import {PropsWithChildren} from 'utilities/props';

import {LayoutContext} from '../context';

type SlotName = 'Content' | 'Brand' | 'LearnMore' | 'Generic';

export function Slot({name, children}: PropsWithChildren<{name: SlotName}>) {
  const {onSlotAdded} = useContext(LayoutContext);
  useEffect(() => onSlotAdded(name, children), [children, name, onSlotAdded]);
  return null;
}
